export default{
  carriers: (state) => state.carriers,
  carrierZhs: (state) => state.carrierZhs
}



// WEBPACK FOOTER //
// ./src/components/carrier/store/getters.js